// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PayloadCreator__container-ba811e {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0 8px 0;
  position: relative;
}

.PayloadCreator__payload-cc3a05 {
  margin-inline-start: 16px;
}

.PayloadCreator__menu-ec15c0 {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/PayloadCreator/PayloadCreator.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 0 8px 0;\n  position: relative;\n}\n\n.payload {\n  margin-inline-start: 16px;\n}\n\n.menu {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PayloadCreator__container-ba811e`,
	"payload": `PayloadCreator__payload-cc3a05`,
	"menu": `PayloadCreator__menu-ec15c0`
};
module.exports = ___CSS_LOADER_EXPORT___;
